import { ShipmentsActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

const INIT_STATE = {
    loading: false,
    error: null,
    shipments: null,
    loadingShipmentSurcharges: false,
    shipmentSurcharges: null,
    shipmentSurchargesPagination: PAGINATION_DEFAULT_VALUE,
    errorGetShipmentSurcharges: null,
    loadingNonShipmentSurcharges: false,
    nonShipmentSurcharges: null,
    nonShipmentSurchargesPagination: PAGINATION_DEFAULT_VALUE,
    errorGetNonShipmentSurcharges: null,
    loadingOrder: false,
    order: null,
    creatingManifest: false,
    manifest: null,
    pagination: PAGINATION_DEFAULT_VALUE,
    loadingShipment: false,
    shipment: null,
    errorShipment: null,
    loadingShipmentsReport: false,
    errorGetShipmentsReport: null,
    shipmentsReport: null,
    ratingShipments: false,
    ratingShipmentsResult: null,
};

type ShipmentsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
//TODO: define data type for shipments (orders)
type State = {
    loading: Boolean,
    error?: null,
    shipments: any,
    loadingShipmentSurcharges: Boolean,
    shipmentSurcharges: any,
    shipmentSurchargesPagination: any,
    errorGetShipmentSurcharges: null,
    loadingNonShipmentSurcharges: Boolean,
    nonShipmentSurcharges: any,
    nonShipmentSurchargesPagination: any,
    errorGetNonShipmentSurcharges: null,
    loadingOrder: Boolean,
    order: any,
    creatingManifest: Boolean,
    manifest: any,
    loadingShipment: Boolean,
    shipment: any,
    errorShipment: null,
    loadingShipmentsReport: Boolean,
    errorGetShipmentsReport: null,
    shipmentsReport: any,
    ratingShipments: Boolean,
    ratingShipmentsResult: any,
};

const Shipments = (state: State = INIT_STATE, action: ShipmentsAction): any => {
    //console.log(action);
    switch (action.type) {
        case ShipmentsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ShipmentsActionTypes.GET_ALL_SHIPMENTS: {
                    return {
                        ...state,
                        loading: false,
                        shipments: action.payload.data.shipments,
                        pagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                case ShipmentsActionTypes.GET_SHIPMENT_BY_EXTERNAL_ORDER_ID: {
                    return { ...state, loadingShipment: false, shipment: action.payload.data };
                }
                case ShipmentsActionTypes.GET_SHIPMENT_SURCHARGES: {
                    return {
                        ...state,
                        loadingShipmentSurcharges: false,
                        shipmentSurcharges: action.payload.data.shipmentSurcharges,
                        shipmentSurchargesPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                case ShipmentsActionTypes.GET_NON_SHIPMENT_SURCHARGES: {
                    return {
                        ...state,
                        loadingNonShipmentSurcharges: false,
                        nonShipmentSurcharges: action.payload.data.nonShipmentSurcharges,
                        nonShipmentSurchargesPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                case ShipmentsActionTypes.GET_ORDER: {
                    return { ...state, loadingOrder: false, order: action.payload.data };
                }
                case ShipmentsActionTypes.CREATE_MANIFEST: {
                    return { ...state, creatingManifest: false, manifest: action.payload.data };
                }
                case ShipmentsActionTypes.GET_ALL_SHIPMENTS_REPORT: {
                    return { ...state, loadingShipmentsReport: false, shipmentsReport: action.payload.data };
                }
                case ShipmentsActionTypes.RATE_SHIPMENTS: {
                    return {
                        ...state,
                        ratingShipments: false,
                        ratingShipmentsResult: action.payload.data,
                    };
                }
                default:
                    return { ...state, loading: false, loadingShipment: false, shipment: null, errorShipment: null, loadingShipmentsReport: false, errorGetShipmentsReport: null, shipmentsReport: null };
            }

        case ShipmentsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ShipmentsActionTypes.GET_ALL_SHIPMENTS: {
                    return { ...state, loading: false, error: action.payload.error };
                }
                case ShipmentsActionTypes.GET_SHIPMENT_BY_EXTERNAL_ORDER_ID: {
                    return { ...state, loadingShipment: false, errorShipment: action.payload.error };
                }
                case ShipmentsActionTypes.GET_SHIPMENT_SURCHARGES: {
                    return { ...state, loadingShipmentSurcharges: false, errorGetShipmentSurcharges: action.payload.error };
                }
                case ShipmentsActionTypes.GET_NON_SHIPMENT_SURCHARGES: {
                    return { ...state, loadingNonShipmentSurcharges: false, errorGetNonShipmentSurcharges: action.payload.error };
                }
                case ShipmentsActionTypes.GET_ORDER: {
                    return { ...state, loadingOrder: false, error: action.payload.error };
                }
                case ShipmentsActionTypes.CREATE_MANIFEST: {
                    return { ...state, creatingManifest: false, error: action.payload.error };
                }
                case ShipmentsActionTypes.GET_ALL_SHIPMENTS_REPORT: {
                    return { ...state, loadingShipmentsReport: false, errorGetShipmentsReport: action.payload.error };
                }
                case ShipmentsActionTypes.RATE_SHIPMENTS: {
                    return { ...state, ratingShipments: false, error: action.payload.error };
                }
                default:
                    return { ...state, loading: false };
            }

        case ShipmentsActionTypes.GET_ALL_SHIPMENTS:
            return { ...state, loading: true, shipments: null };
        case ShipmentsActionTypes.GET_SHIPMENT_SURCHARGES:
            return { ...state, loadingShipmentSurcharges: true, shipmentSurcharges: null };
        case ShipmentsActionTypes.GET_NON_SHIPMENT_SURCHARGES:
            return { ...state, loadingNonShipmentSurcharges: true, nonShipmentSurcharges: null };
        case ShipmentsActionTypes.GET_SHIPMENT_BY_EXTERNAL_ORDER_ID:
            return { ...state, loadingShipment: true, shipment: null };
        case ShipmentsActionTypes.GET_ORDER:
            return { ...state, loadingOrder: true, order: null };
        case ShipmentsActionTypes.CREATE_MANIFEST:
            return { ...state, creatingManifest: true, manifest: null };
        case ShipmentsActionTypes.GET_ALL_SHIPMENTS_REPORT:
            return { ...state, loadingShipmentsReport: true, shipmentsReport: null };
        case ShipmentsActionTypes.RATE_SHIPMENTS:
            return { ...state, ratingShipments: true, ratingShipmentsResult: null };
        case ShipmentsActionTypes.RESET_STATE:
            return INIT_STATE;
        case ShipmentsActionTypes.RESET_ALL_ERRORS:
            return { ...state, error: null };
        default:
            return { ...state };
    }
};

export default Shipments;
